import { render, staticRenderFns } from "./MessageComponent.vue?vue&type=template&id=0d4a1c19&scoped=true&"
import script from "./MessageComponent.vue?vue&type=script&lang=js&"
export * from "./MessageComponent.vue?vue&type=script&lang=js&"
import style0 from "./MessageComponent.vue?vue&type=style&index=0&id=0d4a1c19&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d4a1c19",
  null
  
)

export default component.exports